const modalBus: any = {};

modalBus.install = function(Vue) {
  Vue.prototype.$edEventBus = new Vue();
}

export default modalBus;